<template>
    <div class="navbar">
        <div class="navbar__head">
            <!-- NAV LOGO LINK START  -->
            <div class="navbar__link">
                <router-link to="/">
                <span class="logo">CL</span>
                </router-link>
            </div>
            <!-- NAV LOGO LINK END  --> 
          
            <!-- NAV HISTORY LINK START  -->
            <div class="navbar__link"> 
                <router-link to="/history"> 
                <svg 
                    height="35px" 
                    viewBox="0 0 256 256" 
                    width="35px" 
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="m202.243 164.881a2.489 2.489 0 0 1 -1.768-.733l-8.88-8.88a2.5 2.5 0 0 1 -.733-1.768v-17.029a2.5 2.5 0 0 1 5 0v15.994l8.148 8.148a2.5 2.5 0 0 1 -1.767 4.268z" fill="#fff"/>
                    <path d="m215.38 131.482a31.135 31.135 0 0 0 -46.363 41.424h-4.18a2.5 2.5 0 0 0 0 5h10.485a2.5 2.5 0 0 0 2.5-2.5v-10.484a2.5 2.5 0 0 0 -5 0v4.734a26.127 26.127 0 1 1 18.274 9.885 2.5 2.5 0 1 0 -.431 4.98q1.357.12 2.707.118a31.139 31.139 0 0 0 22.008-53.157z" fill="#fff"/>
                    <path d="m193.362 194.5a2.5 2.5 0 0 0 -2.5 2.5v13.936a2.5 2.5 0 0 1 -2.5 2.5h-120.724a2.5 2.5 0 0 1 -2.5-2.5v-126.02h39.851a2.5 2.5 0 0 0 2.5-2.5v-39.852h80.873a2.5 2.5 0 0 1 2.5 2.5v65.936a2.5 2.5 0 0 0 5 0v-65.936a7.509 7.509 0 0 0 -7.5-7.5h-81.3a7.452 7.452 0 0 0 -5.3 2.2l-39.427 39.419a7.548 7.548 0 0 0 -2.2 5.3v126.45a7.509 7.509 0 0 0 7.5 7.5h120.727a7.509 7.509 0 0 0 7.5-7.5v-13.933a2.5 2.5 0 0 0 -2.5-2.5zm-90.873-148.4v33.816h-33.816z" fill="#fff"/>
                    <g fill="#65c1d6">
                    <path d="m169.239 110.034h-82.478a2.5 2.5 0 0 1 0-5h82.478a2.5 2.5 0 0 1 0 5z"/>
                    <path d="m149.239 137.5h-62.478a2.5 2.5 0 0 1 0-5h62.478a2.5 2.5 0 1 1 0 5z"/>
                    <path d="m149.239 164.966h-62.478a2.5 2.5 0 0 1 0-5h62.478a2.5 2.5 0 1 1 0 5z"/>
                    <path d="m169.239 192.431h-82.478a2.5 2.5 0 0 1 0-5h82.478a2.5 2.5 0 0 1 0 5z"/></g>
                </svg>
                </router-link> 
            </div>
            <!-- NAV HISTORY LINK END  -->

            <!-- NAV COMPARE LINK START  -->
            <div class="navbar__link"> 
                <router-link to="/compare"> 
                <svg  viewBox="0 0 24 24" width="25px" height="25px" fill="#fffc" id="icon-compare"><path data-v-0d904603="" fill-rule="evenodd" clip-rule="evenodd" d="M5.5 7.15088L11 15.7064V16.0001C11 17.23 10.7256 18.7067 9.87944 19.9053C8.99594 21.1568 7.55968 22.0001 5.5 22.0001C3.44033 22.0001 2.00406 21.1568 1.12056 19.9053C0.27439 18.7067 0 17.23 0 16.0001V15.7064L5.5 7.15088ZM2.08102 17.0001C2.1881 17.6425 2.40512 18.257 2.75444 18.7518C3.24594 19.4481 4.05967 20.0001 5.5 20.0001C6.94033 20.0001 7.75406 19.4481 8.24556 18.7518C8.59488 18.257 8.8119 17.6425 8.91898 17.0001H2.08102ZM8.16833 15.0001H2.83167L5.5 10.8494L8.16833 15.0001Z"></path><path data-v-0d904603="" fill-rule="evenodd" clip-rule="evenodd" d="M18.5 7.15088L24 15.7064V16.0001C24 17.23 23.7256 18.7067 22.8794 19.9053C21.9959 21.1568 20.5597 22.0001 18.5 22.0001C16.4403 22.0001 15.0041 21.1568 14.1206 19.9053C13.2744 18.7067 13 17.23 13 16.0001V15.7064L18.5 7.15088ZM15.081 17.0001C15.1881 17.6425 15.4051 18.257 15.7544 18.7518C16.2459 19.4481 17.0597 20.0001 18.5 20.0001C19.9403 20.0001 20.7541 19.4481 21.2456 18.7518C21.5949 18.257 21.8119 17.6425 21.919 17.0001H15.081ZM21.1683 15.0001H15.8317L18.5 10.8494L21.1683 15.0001Z"></path><path data-v-0d904603="" d="M12 2C12.7403 2 13.3866 2.4022 13.7324 3H21V5H13.7324C13.3866 5.5978 12.7403 6 12 6C11.2597 6 10.6134 5.5978 10.2676 5H3V3H10.2676C10.6134 2.4022 11.2597 2 12 2Z"></path></svg>
                </router-link>  
            </div>
            <!-- NAV COMPARE LINK END  -->  

            <!-- NAV FAVS LINK START  -->
            <div class="navbar__link"> 
                <router-link to="/favorites"> 
                    <svg version="1.1" id="Capa_1" width="25px" height="25px" fill="#fffc" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	                    viewBox="0 0 512 512" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M378.667,21.333c-56.792,0-103.698,52.75-122.667,77.646c-18.969-24.896-65.875-77.646-122.667-77.646
                                    C59.813,21.333,0,88.927,0,172c0,45.323,17.99,87.562,49.479,116.469c0.458,0.792,1.021,1.521,1.677,2.177l197.313,196.906
                                    c2.083,2.073,4.802,3.115,7.531,3.115s5.458-1.042,7.542-3.125L467.417,283.74l2.104-2.042c1.667-1.573,3.313-3.167,5.156-5.208
                                    c0.771-0.76,1.406-1.615,1.896-2.542C499.438,245.948,512,209.833,512,172C512,88.927,452.188,21.333,378.667,21.333z
                                    M458.823,261.948c-0.292,0.344-0.563,0.708-0.802,1.083c-1,1.146-2.094,2.156-3.177,3.188L255.99,464.927L68.667,277.979
                                    c-0.604-1.188-1.448-2.271-2.479-3.177C37.677,249.906,21.333,212.437,21.333,172c0-71.313,50.24-129.333,112-129.333
                                    c61.063,0,113.177,79.646,113.698,80.448c3.938,6.083,14,6.083,17.938,0c0.521-0.802,52.635-80.448,113.698-80.448
                                    c61.76,0,112,58.021,112,129.333C490.667,205.604,479.354,237.552,458.823,261.948z"/>
                            </g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                    </svg> 
                </router-link>  
            </div>
            <!-- NAV FAVS LINK END  -->  
        </div>
        
        <div class="navbar__bottom">
            <div class="navbar__link logout"> 
            <button class="logout" @click="logout">
                <svg 
                width="20px"
                version="1.1" 
                id="Layer_1" xmlns="http://www.w3.org/2000/svg" 
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px" 
                y="0px"
                viewBox="0 0 512 512"
                style="enable-background:new 0 0 512 512;"
                xml:space="preserve"
                fill="#fff">
                <g>
                    <g>
                    <path d="M360.507,171c8.284,0,15-6.716,15-15V45c0-24.813-20.187-45-45-45h-240c-24.813,0-45,20.187-45,45v422
                        c0,24.813,20.187,45,45,45h240c24.813,0,45-20.187,45-45V356c0-8.284-6.715-15-15-15c-8.284,0-15,6.716-15,15v111
                        c0,8.271-6.729,15-15,15h-240c-8.271,0-15-6.729-15-15V45c0-8.271,6.729-15,15-15h240c8.271,0,15,6.729,15,15v111
                        C345.507,164.284,352.223,171,360.507,171z"/>
                    </g>
                </g>
                <g>
                    <g>
                    <path d="M460.15,243.74l-61.421-43.301c-6.771-4.774-16.128-3.153-20.902,3.617c-4.773,6.771-3.154,16.129,3.617,20.903
                        L404.198,241h-231.19c-8.284,0-15,6.716-15,15s6.716,15,15,15h231.19l-22.754,16.042c-6.771,4.773-8.391,14.132-3.617,20.903
                        c4.776,6.774,14.135,8.389,20.902,3.617l61.421-43.301C468.685,262.244,468.529,249.646,460.15,243.74z"/>
                    </g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                </svg>
            </button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';

export default {
    methods: {
        ...mapMutations({
            loginUser: 'auth/loginUser'
        }),
        clearSession() {
            if(cookieBridge.getCookie('access_token') != undefined && cookieBridge.getCookie('refresh_token') != undefined) {
                cookieBridge.deleteCookie('access_token');
                cookieBridge.deleteCookie('refresh_token');
                cookieBridge.deleteCookie('expires_in'); 
            }
        },
        logout() { 
            this.$router.push({name: 'Login'}, () => {}); 
            setTimeout(() => {
                this.loginUser(false); 
                this.clearSession();  
            }, 300);
        }
    }
}
// https://hilfy.atlassian.net/browse/CL-40
</script>
<style lang="scss" scoped>
@import '@/assets/scss/main.scss';

.navbar {
  width: 100%; 
  max-width: 74px;
  min-width: 74px;
  height: 100vh; 
  background-color: $mainColor;
  padding: 30px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  animation: fromOpacity .8s ease-out;

  &__head {

  }

  &__link {
    display: flex;
    width: 100%;
    justify-content: center;
    padding: 15px 0;
    
    a, .logout {
      background-color: transparent;
      border: 1px solid #ffffff2b;
      color: #fff;
      text-decoration: none;
      padding: 5px;
      width: 65%;
      height: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: border .3s ease-out;

      &:hover {
        cursor: pointer;
        border: 1px solid #ffffff7a;
      }
    }

    .logout {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-left: 10px;
    }
  }
}
</style>

<style>
.router-link-exact-active {
    border: 1px solid #fff !important;
}
</style>